import React from 'react';
import styles from './RepairRequestDetails.module.css';

// Keep the two identifiers explicitly labelled; never infer or swap imported values.
export default function EquipmentSummary({ equipment, showStatus = true }) {
  return (
    <div className={styles.equipmentDetails}>
      <dl className={styles.equipmentIdentity}>
        <div>
          <dt>Серийный номер</dt>
          <dd className={styles.serialNumber}>{equipment.serial_number || 'Не указан'}</dd>
        </div>
        <div>
          <dt>Модель</dt>
          <dd>{equipment.equipment_model || 'Не указана'}</dd>
        </div>
      </dl>
      {showStatus && (
        <div className={styles.equipmentStatuses}>
          <span className={styles.stageBadge}>
            <span>Этап:</span> {equipment.location_status_display || 'Не указан'}
          </span>
          {equipment.repair_status && (
            <span className={styles.repairBadge}>
              <span>Ремонт:</span> {equipment.repair_status_display || 'Не указан'}
            </span>
          )}
        </div>
      )}
    </div>
  );
}
